import React from 'react';
import ReactDOM from 'react-dom/client';
import { useStore } from '@app/store';
import { loadLocale } from '@constants/locales';
import App from './app/App.jsx';
import preloadCookieFontFromQuery from './pages/cookie-center/preload-cookie-font';
/* eslint-enable import/order */

// NOTE: modals are no longer registered eagerly here. Each surface registers its own modals
// lazily (register-cookie / register-consent / register-assessment / register-requests) so a
// domain's modal code only loads with that surface's chunk. See those files + the route split.

const bootstrap = async () => {
  // Kick off the cookie-center custom-font download before any awaits so it
  // overlaps locale loading and the first render.
  preloadCookieFontFromQuery();
  const initialLocale = useStore.getState().locale;
  await loadLocale(initialLocale);
  ReactDOM.createRoot(document.getElementById('root')).render(<App />);
};

bootstrap();
